import { Collection } from 'modules/core/lib/mobx-rest'

import Team from 'modules/teams/store/models/Team'

class Teams extends Collection<Team> {
  get cacheKey(): string {
    return 'teams'
  }

  model() {
    return Team
  }
}

const singleton: Teams = new Teams()

export { Teams }

export default singleton
